"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetIcon = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
require("../input.types");
const ResetIcon = ({ isError, }) => {
    const theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("circle", { cx: "12", cy: "12", r: "9", fill: isError ? theme.colors.icon.error : theme.colors.neutral[50] }),
        react_1.default.createElement("path", { d: "M8 8L16 16", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round" }),
        react_1.default.createElement("path", { d: "M8 16L16 8", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round" })));
};
exports.ResetIcon = ResetIcon;
